<template>
  <div class="footerContainer">
    <div class="wrapper footerContent">
      <router-link to="/" class="footerLogo">
        <img src="@/assets/imgs/common/logo.png" alt="多点美好" />
        <!-- <span class="navbarName">多点美好</span> -->
      </router-link>
      <div class="footerSections">
        <!-- 联系我们 -->
        <div class="footerSection">
          <h3 class="section-title">联系我们</h3>
          <div class="section-content">
            <div
              v-for="item in $publicData.contactList"
              :key="item.label"
              class="section-content-item"
            >
              <div class="itemLabel">{{ item.label }}</div>
              <div class="itemValue">{{ item.value }}</div>
            </div>
          </div>
        </div>
        <div class="tab-navigation">
          <!-- 关于我们部分 -->
          <div class="footerAbout">
            <h3 class="section-title">关于我们</h3>
            <div class="section-content">
              <p>
                <router-link to="/about#companyProfileID" class="footer-link"
                  >业务介绍</router-link
                >
              </p>
              <p>
                <router-link
                  to="/about#developmentHistoryID"
                  class="footer-link"
                  >发展历程</router-link
                >
              </p>
              <p>
                <router-link to="/about#DMLifeID" class="footer-link"
                  >多美生活</router-link
                >
              </p>
            </div>
          </div>
          <!-- 成长关怀部分 -->
          <div class="footerGrowthCare">
            <h3 class="section-title">成长关怀</h3>
            <div class="section-content">
              <p>
                <router-link to="/growthCare#focusOnPeople" class="footer-link"
                  >人才发展</router-link
                >
              </p>
              <p>
                <router-link to="/growthCare#growthPlan" class="footer-link"
                  >晋升机制</router-link
                >
              </p>
              <p>
                <router-link
                  to="/growthCare#salaryProtection"
                  class="footer-link"
                  >薪酬保障</router-link
                >
              </p>
              <p>
                <router-link
                  to="/growthCare#employeeBenefits"
                  class="footer-link"
                  >福利体系</router-link
                >
              </p>
            </div>
          </div>

          <!-- 我们的文化 -->
          <div class="footerCompanyCulture">
            <h3 class="section-title">我们的文化</h3>
            <div class="section-content">
              <p>
                <router-link
                  to="/companyCulture#cultureMission"
                  class="footer-link"
                  >多美使命</router-link
                >
              </p>
              <p>
                <router-link
                  to="/companyCulture#culturalValues"
                  class="footer-link"
                  >多美价值观</router-link
                >
              </p>
              <p>
                <router-link
                  to="/companyCulture#culturalLife"
                  class="footer-link"
                  >文化生活</router-link
                >
              </p>
            </div>
          </div>

          <!-- 招聘职位部分 -->
          <div class="footerJobVacancy">
            <h3 class="section-title">招聘职位</h3>
            <div class="section-content">
              <p>
                <a
                  href="https://www.zhipin.com/gongsi/job/3402ab67194d2e271nB42Ny5GQ~~.html?ka=company-jobs"
                  class="footer-link"
                  target="_blank"
                  >招聘职位</a
                >
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="wrapper footer_line"></div>
    <div class="wrapper footerCopyright">
      ©2018-2025 安徽多点美好智能科技有限公司 版权所有 
      <a href="https://beian.miit.gov.cn" class="copyright" target="_blank"
        >皖ICP备18022425号-1</a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "AppFooter",
  data() {
    return {};
  },
};
</script>

<style scoped lang="scss" src="@/assets/styles/pc/footer.scss"></style>
